import React from "react";

import type { FeatureIconName } from "./landingPage.types";

import styles from "./FeatureIcon.module.css";

const FeatureIcon = ({ name }: { name: FeatureIconName }) => {
	if (name === "tree") {
		return (
			<svg aria-hidden="true" className={styles.featureIcon} viewBox="0 0 64 64">
				<path d="M32 10v28M18 38h28M18 38v10M46 38v10M32 38v10" />
				<rect height="10" rx="3" width="10" x="27" y="6" />
				<rect height="10" rx="3" width="10" x="13" y="48" />
				<rect height="10" rx="3" width="10" x="27" y="48" />
				<rect height="10" rx="3" width="10" x="41" y="48" />
			</svg>
		);
	}

	if (name === "relations") {
		return (
			<svg aria-hidden="true" className={styles.featureIcon} viewBox="0 0 64 64">
				<path d="M16 22h32M42 16l8 6-8 6M48 42H16M22 36l-8 6 8 6" />
				<path d="M24 10a28 28 0 0 1 16 0M40 54a28 28 0 0 1-16 0" />
			</svg>
		);
	}

	if (name === "collaboration") {
		return (
			<svg aria-hidden="true" className={styles.featureIcon} viewBox="0 0 64 64">
				<circle cx="24" cy="22" r="9" />
				<circle cx="43" cy="27" r="7" />
				<path d="M8 54c2-12 9-18 16-18s14 6 16 18M35 43c3-4 7-6 11-5 5 1 9 6 10 16" />
			</svg>
		);
	}

	return (
		<svg aria-hidden="true" className={styles.featureIcon} viewBox="0 0 64 64">
			<circle cx="32" cy="32" r="23" />
			<path d="M9 32h46M32 9c8 8 12 16 12 23S40 47 32 55M32 9C24 17 20 25 20 32s4 15 12 23" />
		</svg>
	);
};

export default FeatureIcon;
